import React, { Dispatch, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import VulnerabilityOverview from './components/Views/VulnerabilitySelectionView/VulnerabilityOverview';
import { getSettings } from './redux/user/sliceUserSettings';

export default () => {
    /** Allows reducers on redux slices to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Fetch the user's settings when the application loads. */
    useEffect(() => {
        dispatch(getSettings(null));
    }, []);

    return (
        <Routes>
            <Route path='/' element={<VulnerabilityOverview />} />
        </Routes>
    );
};
